import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { Button } from './Button'
import { Div } from './Div'
import { Color, theme } from '../constants'

type HeaderNavProps = {
  className?: string
  slotStart?: ReactNode
  slotMiddle?: ReactNode
  slotEnd?: ReactNode
}

const Nav = styled.nav`
  display: flex;
  align-items: center;
  position: relative;
  background-color: ${Color.BLUE};
  color: ${Color.WHITE};
  padding: ${theme.spacing[1]}px;
  min-height: 50px;
`

const Start = styled(Div)`
  z-index: 1;
`

const Middle = styled(Div)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  inset: 0;
  padding-left: 90px;
  padding-right: 90px;
`

const End = styled(Div)`
  z-index: 1;
  margin-left: auto;
`

const HeaderNav = ({
  className,
  slotStart,
  slotMiddle,
  slotEnd,
}: HeaderNavProps) => {
  return (
    <Nav className={className}>
      {slotStart && <Start>{slotStart}</Start>}
      {slotMiddle && <Middle>{slotMiddle}</Middle>}
      {slotEnd && <End>{slotEnd}</End>}
    </Nav>
  )
}

HeaderNav.Title = styled.h1`
  font-size: ${theme.font.size[3]}px;
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

HeaderNav.Button = styled(Button)``

export { HeaderNav }
